import React, {Fragment} from 'react'
import {Link, Route, useParams} from 'react-router-dom'
import {pluralise} from 'admin/lib/format'
import useUsers from 'admin/hooks/useUsers'
import useDocument from 'admin/hooks/useDocument'
import NewUser from 'admin/components/NewUser'
import Pagination from 'admin/components/shared/Pagination'
import Table from './Table'
import Filters from './Filters'
import Page from '../shared/Page'
import useModal from '../../hooks/useModal'
import ModalLink from '../shared/ModalLink'

export default ({match, history}) => {
  const {organisationID} = useParams()
  const {pushModal} = useModal()
  const {users, totalCount, filters, setFilters} = useUsers(organisationID)

  useDocument({title: 'Users'})

  return (
    <Fragment>
      <Route exact path={`${match.path}/new`} component={NewUser} />

      <Page
        title='Manage access'
        subtitle={`Showing ${users.length} of ${pluralise(`user`, totalCount, true)}`}
        buttons={
          <ModalLink modal='new-user' className='button is-light'>
            New user
          </ModalLink>
        }>
        <Filters {...filters} onSubmit={setFilters} />
        {totalCount != 0 ? (
          <Fragment>
            <div className='level'>
              <div className='level-left'></div>
              <div className='level-right'>
                <Pagination
                  page={filters.page}
                  limit={filters.limit}
                  total={totalCount}
                  onChange={setFilters}
                  className='level-item'
                />
              </div>
            </div>
            <Table data={users} onClick={userID => pushModal('user', {userId: userID})} />
            <div className='level'>
              <div className='level-left'></div>
              <div className='level-right'>
                <Pagination
                  page={filters.page}
                  limit={filters.limit}
                  total={totalCount}
                  onChange={setFilters}
                  className='level-item'
                />
              </div>
            </div>
          </Fragment>
        ) : (
          <p>No users</p>
        )}
      </Page>
    </Fragment>
  )
}
